import React, { useState } from "react";
import { Section } from "./primitives";
import { faq as F } from "../mock/inferraData";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <Section id="faq" bg="var(--pink)" pt={150} pb={150}>
      <div className="faq-wrap" style={{ display: "flex", gap: 80, alignItems: "flex-start" }}>
        <h2 className="font-type reveal" style={{ margin: 0, width: 380, flexShrink: 0, fontSize: "clamp(30px,3.6vw,48px)", fontWeight: 700, lineHeight: 1.06, letterSpacing: "-1px" }}>
          {F.heading}
        </h2>
        <div className="reveal d1" style={{ flexGrow: 1 }}>
          {F.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`faq-item ${isOpen ? "open" : ""}`} style={{ borderBottom: i === F.items.length - 1 ? "1px solid var(--line)" : "none" }}>
                <div
                  className="faq-q"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 20, padding: "26px 0", fontSize: "clamp(16px,1.7vw,20px)", fontWeight: 500 }}
                >
                  <span className="font-type">{it.q}</span>
                  <span className="faq-sign" style={{ fontSize: 24, color: "var(--green)", lineHeight: 1, flexShrink: 0 }}>+</span>
                </div>
                <div className="faq-a" style={{ paddingBottom: isOpen ? 26 : 0 }}>
                  <p style={{ margin: 0, maxWidth: 640, fontSize: 15.5, lineHeight: 1.65, color: "var(--ink-soft)" }}>{it.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .faq-wrap { flex-direction: column; gap: 30px; }
          .faq-wrap h2 { width: 100%; }
        }
      `}</style>
    </Section>
  );
}
